import { gql } from "@apollo/client"

export const GET_TOKEN_MUTATION = gql`
mutation getToken($username: String!, $password: String!) {
  tokenAuth(username: $username, password: $password) {
    success
    errors
    unarchiving
    token
    refreshToken
    unarchiving
    user {
      id
      username
    }
  }
}
`

export const GET_REFRESH_TOKEN_MUTATION = gql`
mutation RefreshToken($refreshToken: String!) {
  refreshToken(refreshToken: $refreshToken) {
    token
    refreshToken
  }
}
`